// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__wRoG1","hidden":"style_hidden__hrcC7","error":"style_error__hQo_y"};